module.exports = __webpack_public_path__ + "static/2-986a6d5dfec0dfc6690ce5b1c7393001.jpeg";